var checkUserInfo = function() {
    var cookieName = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "userInfo";
    // Return if called on server
    if (typeof document === "undefined") {
        return;
    }
    var userInfoCookie = document.cookie.split("; ").find(function(row) {
        return row.startsWith(cookieName);
    });
    if (userInfoCookie) {
        return JSON.parse(decodeURIComponent(userInfoCookie.split("=")[1]));
    }
    return;
};
export default checkUserInfo;
